import styled from 'styled-components';
// import { color } from 'styles/pallete';

export const container = styled.div``;
